import React, { FC, useEffect } from 'react';

import { Fit, Layout, useRive } from '@rive-app/react-canvas';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { onAssetLoad } from '~/utils/animations';

import styles from './styles.module.scss';
import AnimationSrc from '../../assets/input_limit_overflow.riv';

const getTexts = (data: {
  t: TFunction;
  increaser: number;
  inputCurrent: number;
  inputLimit: number;
}): { runName: string; text: string }[] => {
  const { t, increaser, inputCurrent, inputLimit } = data;
  return [
    {
      runName: 'LargerInput',
      text: t('modal:feature_unlock.input_limit_animation_text[0]', {
        increaser,
        defaultValue: '{{increaser}}x larger input',
      }),
    },
    {
      runName: 'WordsAmount',
      text: t('modal:feature_unlock.input_limit_animation_text[1]', {
        words_range: `${inputCurrent}/${inputLimit}`,
        defaultValue: '{{words_range}} words',
      }),
    },
    {
      runName: 'EnoughWords',
      text: t(
        'modal:feature_unlock.input_limit_animation_text[2]',
        'And in this article, we discuss the multi-layered significance of the correct order and how it affects communication as well credibility from various angles.',
      ),
    },
    {
      runName: 'NotEnoughWords',
      text: t(
        'modal:feature_unlock.input_limit_animation_text[3]',
        'Appreciating grammar means seeing it as a way to communicate and connect with others rather than just following rules. Whether you are writing a business proposal or an academia',
      ),
    },
  ];
};

type Props = {
  increaser: number;
  inputCurrent: number;
  inputLimit: number;
};

const InputLimitOverflowAnimation: FC<Props> = ({
  increaser,
  inputCurrent,
  inputLimit,
}) => {
  const { t } = useTranslation();

  const { rive, RiveComponent } = useRive({
    src: AnimationSrc,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
    }),
    assetLoader: onAssetLoad,
  });

  useEffect(() => {
    if (rive) {
      getTexts({
        t,
        increaser,
        inputCurrent,
        inputLimit,
      }).forEach(({ runName, text }) => {
        rive.setTextRunValue(runName, text);
      });
    }
  }, [rive]);

  return (
    <div className={styles.animation}>
      <RiveComponent />
    </div>
  );
};

export default InputLimitOverflowAnimation;
